<template>
	<skySelectCard class="checkGroups">
		<template slot="header">
			<div>可添加的列</div>
		</template>
		<div class="checkGroups_panel">
			<el-scrollbar>
				<div class="checkItem" v-for="(item, key) in myArray" :key="key">
					<div class="checkLabel">{{ key }}</div>
					<el-row>
						<el-col :span="8" v-for="y in item" :key="y.columnCode">
							<el-tooltip
								:content="y.formulaToCalculate"
								placement="top"
								:disabled="y.formulaToCalculate ? false : true"
							>
								<el-checkbox v-model="y.check" @change="onChange">
									{{ y.columnName }}
								</el-checkbox>
							</el-tooltip>
						</el-col>
					</el-row>
				</div>
			</el-scrollbar>
		</div>
	</skySelectCard>
</template>
<script>
import skySelectCard from '../sky-select-card.vue';
export default {
	name: 'checkGroups',
	components: {
		skySelectCard
	},
	props: {
		value: {
			type: Array,
			default: function () {
				return [];
			},
		},
		data: {
			type: Array
		}
	},
	computed: {
		myArray() {
			let data = this.data.filter(item => item.parentCode !== 'fixedPosition');
			data.forEach(item => {
				item.check = false;
			});
			const valueKeys = this.value.map(item => item.columnCode);
			data.forEach(item => {
				if (valueKeys.indexOf(item.columnCode) !== -1) {
					item.check = true;
				}
			});
			return _.groupBy(data, 'parentName');
		},
		checked() {
			return this.data.filter(item => item.check);
		}
	},
  
	methods: {
		onChange() {
			this.$nextTick(() => {
				this.$emit('input', this.checked);
			})
		}
	}
};
</script>
<style lang="scss">
.checkGroups {
	.select-card-title {
		padding: 10px 18px;
	}

	.checkGroups_panel {
		padding: 10px;

		.el-scrollbar__wrap {
			height: 514px;
		}

		.checkItem {
			.checkLabel {
        padding: 10px 0px 6px;
				color: #333333;
			}
		}
	}
}
</style>
